// Shops we vouch for, and why — an editorial opinion, presented as one.
//
// Everything else in this app reports what a provider told us. This file does
// not: it is the developer's own view, arrived at from local knowledge rather
// than from data, and the UI has to attribute it that way. "Recommended" here
// means a person thinks well of the chain. It is NOT any of the following, and
// no caller may treat it as such:
//
//   * Not a stock claim. We have no inventory data for any branch, so a
//     recommended shop is not "the one that has your ingredients". A
//     recommended supermarket that happens not to carry tamarind paste still
//     carries the recommendation, because the recommendation was never about
//     tamarind paste.
//
//   * Not a pickup claim. Nothing here has been checked for online pickup, and
//     a recommendation must never be rendered near wording that implies it has.
//     Verified pickup is a per-retailer integration and does not exist yet.
//
//   * Not a source of stores. This file recognises brands in results the
//     provider actually returned. It holds no addresses and no coordinates, and
//     it can never introduce a branch into the list — if the lookup found no
//     ALDI within range, there is no ALDI within range, and we say nothing.
//
// That last point is why there is no geography here. An earlier sketch gated
// the recommendation on the user being in a state the chain operates in, which
// needed a state from the geocoder (and gave nothing at all for device GPS)
// to answer a question the search results already answer better. A brand is
// relevant exactly when a branch of it turned up nearby.
//
// It fails OPEN in both directions: an unrecognised shop simply has no opinion
// attached and ranks on its own merits, and a recommended shop that is far away
// stays far away — see rankStores.js, where this can only reorder branches that
// are already the same distance from the user.
//
// NOT a mock. There is no provider behind this to swap in.

// Split on anything that is not a letter or digit so a brand matches as a whole
// word: "Baldini's Market" does not become an ALDI.
function tokensOf(name) {
  return String(name || '')
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(Boolean);
}

// One entry, deliberately. A recommendation is a claim a person is standing
// behind, so this list grows when someone actually knows the chain — not to
// look comprehensive. `reason` is shown to the user verbatim and should read as
// an opinion, in plain words, without a superlative we cannot support.
const BRANDS = [
  {
    id: 'aldi',
    label: 'ALDI',
    reason: 'Often the cheapest place to fill a whole list.',
    matches: (tokens) => tokens.includes('aldi'),
  },
];

export function recommendationFor(store) {
  if (!store?.name) return null;
  const tokens = tokensOf(store.name);
  return BRANDS.find((brand) => brand.matches(tokens)) ?? null;
}

export function isRecommended(store) {
  return recommendationFor(store) !== null;
}
